import { useStyle } from '@/classify';
import { GET_CART_DETAILS_QUERY } from '@/hooks/SignIn/signIn.gql';
import { useSignIn } from '@/hooks/SignIn/useSignIn';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import { useRouter } from 'next/navigation';
import Button from '../Button';
import Field from '../Field';
import FormError from '../FormError/formError';
import GoogleRecaptcha from '../GoogleReCaptcha';
import Password from '../Password';
import TextInput from '../TextInput';
import defaultClasses from './trackOrderSignIn.module.css';

const TrackOrderSignIn = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const {
    setDefaultUsername = () => {},
    showCreateAccount = () => {},
    showForgotPassword = () => {},
    afterSubmit,
    initialValues,
  } = props;

  const talonProps = useSignIn({
    getCartDetailsQuery: GET_CART_DETAILS_QUERY,
    setDefaultUsername,
    showCreateAccount,
    afterSubmit,
    showForgotPassword,
  });

  const router = useRouter();

  const {
    errors,
    handleCreateAccount,
    handleForgotPassword,
    handleSubmit,
    isBusy,
    loading,
    setFormApi,
    recaptchaWidgetProps,
  } = talonProps;

  return (
    <div className={classes.root}>
      <FormError errors={Array.from(errors.values())} />
      <Form
        className={classes.form}
        onSubmit={handleSubmit}
        initialValues={initialValues && initialValues}
      >
        <Field
          id='email'
          label={<span className='text-[15px]'>Email</span>}
          className={'isRequired'}
          required
        >
          <TextInput
            id='email'
            autoComplete='email'
            field='email'
            validate={isRequired}
          />
        </Field>
        <Password
          fieldName='password'
          id='Password'
          classes={{
            root: classes.password,
          }}
          label={
            <div className={classes.passwordLabel}>
              <span className='text-[15px]'>Password</span>{' '}
              <span
                className={classes.forgotPasswordLink}
                onClick={() => {
                  router.push('/forgot-password');
                }}
              >
                Forgot Your Password?
              </span>
            </div>
          }
          validate={isRequired}
          autoComplete='current-password'
          isToggleButtonHidden={false}
          required
        />

        <GoogleRecaptcha {...recaptchaWidgetProps} />
        <Button
          priority='high'
          className={classes.signInButton}
          type='submit'
          disabled={isBusy}
          loading={loading}
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default TrackOrderSignIn;
